import { render, staticRenderFns } from "./IrInvoicesViewer.vue?vue&type=template&id=2d663fd0&"
import script from "./IrInvoicesViewer.vue?vue&type=script&lang=js&"
export * from "./IrInvoicesViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports